import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const WidgetSurveyContent = props => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        margin: 0,
        padding: 0,
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        display: "flex",
        flexDirection: "column",

        backgroundColor: theme.palette.commonground.main,
        height: "calc(100% - 56px)",
        overflowY: "hidden",
        overflowX: "hidden",
      }}
    >
      {props.children}
    </Box>
  );
};

export default WidgetSurveyContent;
